import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { TenantProvider } from "./contexts/TenantContext";
import { Toaster } from "./components/ui/sonner";

// Auth Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

// Main Modules
import Shipments from "./pages/Shipments";
import Remitentes from "./pages/Remitentes";
import Destinatarios from "./pages/Destinatarios";
import Calculadora from "./pages/Calculadora";
import TrackingPortal from "./pages/TrackingPortal";

// Management
import Furgones from "./pages/Furgones";
import Empleados from "./pages/Empleados";
import Pickups from "./pages/Pickups";
import Nomina from "./pages/Nomina";
import Gastos from "./pages/Gastos";
import Suministros from "./pages/Suministros";
import CuadreDiario from "./pages/CuadreDiario";
import CajaChica from "./pages/CajaChica";
import ScannerQR from "./pages/ScannerQR";
import UsersManagement from "./pages/UsersManagement";
import CompanySettings from "./pages/CompanySettings";
import Reportes from "./pages/Reportes";
import PlatformAdmin from "./pages/PlatformAdmin";
import BottomNav from "./components/BottomNav";

// Private Route Guard with Bottom Nav
const PrivateRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" />;
  if (requiredRole && user?.role !== requiredRole) return <Navigate to="/" />;

  return (
    <>
      <div className="pb-24">{children}</div>
      <BottomNav />
    </>
  );
};

function App() {
  useEffect(() => {
    const saved = localStorage.getItem('app_zoom_level');
    if (saved) {
      const level = parseInt(saved);
      const isMobile = window.innerWidth <= 768;
      const base = isMobile ? 20 : 18;
      document.documentElement.style.fontSize = `${base * (level / 100)}px`;
    }
  }, []);

  return (
    <TenantProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/tracking" element={<TrackingPortal />} />
            <Route path="/tracking/:numero" element={<TrackingPortal />} />

            {/* Private Routes */}
            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/envios" element={<PrivateRoute><Shipments /></PrivateRoute>} />
            <Route path="/remitentes" element={<PrivateRoute><Remitentes /></PrivateRoute>} />
            <Route path="/destinatarios" element={<PrivateRoute><Destinatarios /></PrivateRoute>} />
            <Route path="/calculadora" element={<PrivateRoute><Calculadora /></PrivateRoute>} />
            <Route path="/furgones" element={<PrivateRoute><Furgones /></PrivateRoute>} />
            <Route path="/empleados" element={<PrivateRoute><Empleados /></PrivateRoute>} />
            <Route path="/pickups" element={<PrivateRoute><Pickups /></PrivateRoute>} />
            <Route path="/nomina" element={<PrivateRoute><Nomina /></PrivateRoute>} />
            <Route path="/gastos" element={<PrivateRoute><Gastos /></PrivateRoute>} />
            <Route path="/suministros" element={<PrivateRoute><Suministros /></PrivateRoute>} />
            <Route path="/cuadre-diario" element={<PrivateRoute><CuadreDiario /></PrivateRoute>} />
            <Route path="/caja-chica" element={<PrivateRoute><CajaChica /></PrivateRoute>} />
            <Route path="/scanner-qr" element={<PrivateRoute><ScannerQR /></PrivateRoute>} />
            <Route path="/usuarios" element={<PrivateRoute><UsersManagement /></PrivateRoute>} />
            <Route path="/configuracion" element={<PrivateRoute><CompanySettings /></PrivateRoute>} />
            <Route path="/reportes" element={<PrivateRoute><Reportes /></PrivateRoute>} />
            <Route path="/platform-admin" element={<PrivateRoute requiredRole="platform_admin"><PlatformAdmin /></PrivateRoute>} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </TenantProvider>
  );
}

export default App;
